export default __webpack_public_path__ + "media/zurb/img/party/100-1f0a89e85da7847153ace61d1f5b5f1e.png";